import { Component, inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'rtpca-error-alert',
    standalone: true,
    templateUrl: './error-alert.component.html',
    styles: [``],
    imports: [TranslateModule]
})
export class ErrorAlertComponent {
  snackBarRef = inject<MatSnackBarRef<ErrorAlertComponent>>(MatSnackBarRef);
  data = inject(MAT_SNACK_BAR_DATA);

  get errors(): string[] {
    return this.data?.split(';');
  }
}
